/**
 * React hook for accessing logo assets
 * Returns logos synchronously for instant, zero-delay rendering
 */

import { useEffect, useState } from 'react';
import { getLogos } from '../utils/logoAssets';

interface LogoAssets {
  logoFullLight: string;
  logoFullDark: string;
  logoIconLight: string;
  logoIconDark: string;
}

export function useLogos() {
  // Get initial logos synchronously - no delay
  const [logos, setLogos] = useState<LogoAssets>(() => getLogos());
  const [isLoading] = useState(false); // Always false - logos load instantly

  useEffect(() => {
    // Check for custom logo updates periodically (non-blocking)
    const checkForUpdates = () => {
      const currentLogos = getLogos();
      setLogos(currentLogos);
    };

    // Check once after mount
    const timer = setTimeout(checkForUpdates, 1000);

    return () => clearTimeout(timer);
  }, []);

  return { ...logos, isLoading };
}